module.exports = __webpack_public_path__ + "img/chevron-down-small.6c8d8baf.svg";